import Typograf from 'typograf';

const typograf = new Typograf({ locale: ['ru'] });

export const tp = (str: string) => typograf.execute(str);
